import { render } from "./Attributes.vue?vue&type=template&id=34bb594e&ts=true"
import script from "./Attributes.vue?vue&type=script&lang=ts"
export * from "./Attributes.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/jacob/Work/clevero/trunk/www/frontend/CID/poski/klasik-2020/js/libraries/product-variants/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__